/**
 * @file: 更新组件坐标信息字段，只需要对层板和商品做运算，服务端需要使用，前端不需要使用
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../cubeTree/index';
import CodiSystem from '../codiSystem/index';
import Utils from '../utils/util';
import { cubeModify } from './cubeModify';

// 同步更新
function updateAxisSync(): void {
    let allCubes: Array<CubeId> = CubeTree.getAllCube();

    allCubes.forEach((cubeId: CubeId): void => {
        if (CubeTree.isPartition(cubeId)) {
            updateLayerAxis(cubeId);
            return;
        }

        if (CubeTree.isGoods(cubeId)
            || CubeTree.isBafflePlate(cubeId)
            || CubeTree.isTextarea(cubeId)) {
            updateLayersCubeAxis(cubeId);
        }
    });
}

function updateLayerAxis(layer: CubeId): void {
    let diagonalCoordinate: DiagonalRelativePhysicsCoordinate|null = CodiSystem.getDiagonalRelativePhysicsCoordinate(layer);

    if (!diagonalCoordinate) {
        return;
    }

    cubeModify(layer, {
        specialAttr: {
            startAxis: diagonalCoordinate.leftBottom.join(','),
            endAxis: diagonalCoordinate.rightTop.join(',')
        }
    });
}

// 横杆商品当普通层板处理，忽略商品悬挂状态
function updateLayersCubeAxis(cubeId: CubeId): void {
    let relativePhysicsCoordinate: PhysicsRelativeCoordinate|null = CodiSystem.getRelativePhysicsCoordinate(cubeId);

    if (!relativePhysicsCoordinate) {
        return;
    }

    let right: PhysicsMeasurement = Utils.math(relativePhysicsCoordinate.left, relativePhysicsCoordinate.width, '+');

    cubeModify(cubeId, {
        specialAttr: {
            startAxis: [relativePhysicsCoordinate.left, 0].join(','),
            endAxis: [right, relativePhysicsCoordinate.height].join(',')
        }
    });
}

export {
    updateAxisSync
};
